module.exports = __webpack_public_path__ + "img/rombus.92fed6df.svg";